/* global G */
import redirectSequence from 'lib/hook/router/redirect'
import routeComposition from 'lib/trait/composition/route'
import { curry } from 'lib/util'

/**
 * Gets the correct doc type from the item.
 *
 * @param {Object} item
 * @returns {*|null}
 * @private
 */
const _getDocType = item => item?.meta?.type ?? item?.type ?? item?.value?.docType ?? null

/**
 * Returns the appropriate route for the doc type.
 *
 * @param {Object} item
 * @param {Gaia.Component.Spec} component
 * @private
 * @returns {{module: string, action: string}}
 */
const _getRoute = (item, component) => {
  const type = _getDocType(item)
  const { routes = {}, route = {} } = component[G.CONFIGURATION]

  return routes?.[type] || route || {}
}

const detail = async (module, component, event) => {
  const moduleState = module[G.STATE]
  const { id } = event.detail.item.value
  const route = _getRoute(event.detail.item, component)

  moduleState[G.ROUTE] = routeComposition(route.module, route.action)

  await redirectSequence(module)({ key: id })
}

export default curry(detail)
